<script>
import mixins from "../../mixins/index";
import { BaseSelect } from "@/components";
import { mapGetters } from "vuex";

export default {
  name: "AccordionSubItemForeign",
  mixins: [mixins],
  components: { BaseSelect },
  props: {
    item: Object,
    dataItem: Object,
    isResponsive: Boolean,
  },
  computed: {
    ...mapGetters(["getForeignInfo"]),
    check() {
      return this.dataItem?.foreignIndice?.find(
        (o) => o.foreignIndiceFeature.id === this.item.id
      );
    },
  },
  methods: {
    changeActive() {
      const newCheckedValue = !this.checked;
      this.showSelectbox = !this.showSelectbox;
      this.checked = newCheckedValue;
      return newCheckedValue;
    },
    changeForeign(item) {
      const args = {
        ...item,
        dateSelection: this.startDateSelection,
      };
      this.$emit("changeForeignItems", args);
      this.changeActive();
    },
    changeStartDate(value) {
      this.startDateSelection = value.code;
      const args = {
        ...this.item,
        dateSelection: this.startDateSelection,
      };
      this.$emit("changeForeignItems", args);
    },
    checkStartDateByRow() {
      const getStartDate = this.dataItem.foreignIndice.find(
        (o) => o.foreignIndiceFeature.id === this.item.id
      );

      if (getStartDate != undefined) {
        this.startDateSelection = Number(getStartDate.dateSelection.key);
        this.showSelectbox = true;
      }
    },
  },
  mounted() {
    if (this.check) {
      this.changeActive();
      this.checkStartDateByRow();
      const args = {
        ...this.item,
        dateSelection: this.item?.dateSelection
          ? this.item?.dateSelection
          : this.startDateSelection,
      };
      this.$emit("changeForeignItems", args);
    }
  },
  data() {
    return {
      checked: false,
      itemName: this.item?.name,
      itemFundAmount: this.item?.fundAmount,
      itemCommissionAmount: this.item?.commissionAmount,
      itemPrice: this.item?.price,
      itemPriceInfo: this.item?.priceInfo,
      showSelectbox: false,
      startDateSelection: -1,
      startDate: [
        {
          label: "Seçiniz",
          code: -1,
        },
        {
          label: "Hemen",
          code: 0,
        },
        {
          label: "Ay Başında",
          code: 1,
        },
      ],
    };
  },
};
</script>
<template>
  <tr v-if="!isResponsive" :class="checked ? 'active' : ''">
    <td>
      <input
        type="checkbox"
        :id="itemName"
        class="base-form-checkbox"
        :checked="check && 'checked'"
        @change="changeForeign(item)"
      />
    </td>
    <td>
      {{ itemName }}
    </td>
    <td>
      <div class="table-dropdown m-flex" v-if="itemFundAmount">
        BES / Komisyon: {{ formatPrice(itemFundAmount) }}&nbsp;TL /
        {{ formatPrice(itemCommissionAmount) }}&nbsp;TL
      </div>
      <div v-else class="text-center">-</div>
    </td>
    <td>
      <div class="table-dropdown m-flex" v-if="itemPrice">
        {{ itemPrice }}
        <span v-if="itemPriceInfo == '₺'"> TL </span>
        <span v-else-if="itemPriceInfo == '$'"> USD </span>
        <span v-else-if="itemPriceInfo == '€'"> EUR </span>
      </div>
      <div v-else class="text-center">-</div>
    </td>
    <td v-if="showSelectbox">
      <label :for="`startDate-${item.id}`">Başlangıç zamanı</label>
      <base-select
        fieldLabel="Başlangıç Zamanı"
        :options="startDate"
        :id="`startDate-${item.id}`"
        @change="changeStartDate"
        :selectedId="startDateSelection"
        placeholder="Seçiniz"
        class="start-date-select"
      />
    </td>
    <td v-else>-</td>
  </tr>
  <div
    v-else
    class="responsive-table-container"
    :class="checked ? 'highlight' : ''"
  >
    <div class="mobile-wrap">
      <label class="row caption" :for="'input-' + item.id">
        <input
          type="checkbox"
          :id="itemName"
          class="base-form-checkbox"
          :checked="check && 'checked'"
          @change="changeForeign(item)"
        />
        {{ itemName }}
      </label>
      <div class="row inline">
        <span>BES / Komisyon</span>
        <div v-if="itemFundAmount && itemCommissionAmount">
          {{ formatPrice(itemFundAmount) }}&nbsp;TL /
          {{ formatPrice(itemCommissionAmount) }}&nbsp;TL
        </div>
        <div class="no-data" v-else>-</div>
      </div>
      <div class="row">
        <span v-if="itemPriceInfo == '₺'">{{ itemPrice }} TL </span>
        <span v-else-if="itemPriceInfo == '$'">{{ itemPrice }} USD </span>
        <span v-else-if="itemPriceInfo == '€'">{{ itemPrice }} EUR </span>
      </div>
      <div class="row">
        <span class="title" v-if="showSelectbox">Başlangıç Zamanı</span>
        <base-select
          fieldLabel="Başlangıç Zamanı"
          v-if="showSelectbox"
          :options="startDate"
          id="startTime"
          @change="changeStartDate"
          :selectedId="startDateSelection"
          placeholder="Seçiniz"
          class="start-date-select veri-dagitim-selectbox"
        />
        <div class="no-data" v-else>-</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active {
  background-color: #f9f9fa;
  border-radius: 13px;
}
.responsive-table-container {
  width: 100%;
  .data-container {
    @media (max-width: 460px) {
      width: 65%;
    }
  }
  .title-container {
    font-size: 12px;
    @media (max-width: 460px) {
      width: 35%;
    }
  }
}
.bold {
  font-weight: 700;
}
</style>
